import { TrackMode } from '@fitness-force/enum';

const TRACK_MODE_I18N_KEYS: Record<number, string> = {
  [TrackMode.StaffWebApp]: 'CLIENT_BOOKING.V2.TRACK_MODE_STAFF_WEB',
  [TrackMode.StaffMobileApp]: 'CLIENT_BOOKING.V2.TRACK_MODE_STAFF_MOBILE',
  [TrackMode.ClientMobileApp]: 'CLIENT_BOOKING.V2.TRACK_MODE_CLIENT_APP',
  [TrackMode.ClientPurchasePortal]: 'CLIENT_BOOKING.V2.TRACK_MODE_CLIENT_PORTAL',
  [TrackMode.ClientWebsiteWidget]: 'CLIENT_BOOKING.V2.TRACK_MODE_CLIENT_WIDGET',
  [TrackMode.FFMavrick]: 'CLIENT_BOOKING.V2.TRACK_MODE_FF_MAVRICK',
  [TrackMode.ClientWebSignup]: 'CLIENT_BOOKING.V2.TRACK_MODE_CLIENT_WEB_SIGNUP',
  [TrackMode.FFHangfireJob]: 'CLIENT_BOOKING.V2.TRACK_MODE_FF_HANGFIRE',
  [TrackMode.ClassPass]: 'CLIENT_BOOKING.V2.TRACK_MODE_CLASS_PASS',
  [TrackMode.Widget]: 'CLIENT_BOOKING.V2.TRACK_MODE_WIDGET',
  [TrackMode.FFConsumerApp]: 'CLIENT_BOOKING.V2.TRACK_MODE_FF_CONSUMER_APP',
};

export function getTrackModeI18nKey(
  trackMode: TrackMode | string | number | null | undefined,
): string {
  if (trackMode == null || trackMode === '') {
    return '';
  }
  let numeric: number;
  if (typeof trackMode === 'number') {
    numeric = trackMode;
  } else if (typeof trackMode === 'string') {
    const fromName = TrackMode[trackMode as keyof typeof TrackMode];
    numeric =
      typeof fromName === 'number' ? fromName : Number(trackMode);
  } else {
    numeric = Number(trackMode);
  }
  if (!Number.isNaN(numeric) && TRACK_MODE_I18N_KEYS[numeric]) {
    return TRACK_MODE_I18N_KEYS[numeric];
  }
  return '';
}
